// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__IlMpX","layout-body":"style_layout-body__B4nNo"};